<script setup lang="ts">
defineProps<{
  enabled: boolean
}>()
</script>

<template>
  <button
    type="button"
    class="relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#408F92]/10 focus:ring-offset-2"
    :class="enabled ? 'bg-[#408F92]' : 'bg-gray-200'"
    role="switch"
    aria-checked="false"
  >
    <span class="sr-only">Use setting</span>
    <span
      aria-hidden="true"
      class="pointer-events-none inline-block size-5 h-5 w-5 translate-x-0 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
      :class="enabled ? 'translate-x-5' : 'translate-x-0'"
    ></span>
  </button>
</template>
